import _get from 'lodash/get';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { getOrderStatusToRender } from 'helper/history-order';
import css from './order-status.less';

const cx = classnames.bind(css);

const OrderStatus = props => {
  const { order } = props;
  const text = getOrderStatusToRender(order);

  return (
    <div>
      <span className={cx('commonStatus', css[_get(order, 'status')])}>
        {text}
      </span>
    </div>
  );
};

OrderStatus.propTypes = {
  order: PropTypes.shape({}),
};

OrderStatus.defaultProps = {
  order: {},
};

export default OrderStatus;
